import React, { useEffect, useState } from 'react';
import { useGetMyChallenges } from 'src/hooks/prepPlan.hooks';
import { UIMyChallenges, UIPrepPlan } from 'types';
import ChallengeCard from '../challenges/ChallengeCard';
interface Props {
	prepPlan: UIPrepPlan;
}
const OtherChallenges = ({ prepPlan }: Props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { data, isLoading, isError, refetch } = useGetMyChallenges();
	// get 2 challenges whose title is not equal to the current challenge
	const [otherChallenges, setOtherChallenges] = React.useState<UIMyChallenges[]>([]);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [maxLength, setMaxLength] = useState<number>(15);

	useEffect(() => {
		if (window.innerWidth < 960) {
			setMaxLength(15);
		} else {
			setMaxLength(28);
		}
	}, []);

	useEffect(() => {
		if (data?.challenges) {
			const filteredChallenges = data.challenges.filter(challenge => challenge.title !== prepPlan.title);
			// get 2 challenges if there are more than 2
			const otherChallenges = filteredChallenges.length > 2 ? filteredChallenges.slice(0, 2) : filteredChallenges;
			setOtherChallenges(otherChallenges);
		}
	}, [data, prepPlan.title]);

	return (
		<div>
			<p className="text-[20px] font-[600] leading-[24px] font-inter dark:text-[#CDF] text-[#1F3343] mb-[10px]">Other Challenges</p>
			<div className="border dark:border-[rgba(199,_201,_217,_0.10)] p-[20px] dark:bg-[#1F2A37] bg-[#FFF] relative isolate rounded-[12px]">
				<div
					className="absolute w-full h-full top-0 left-0 z-[-1] rounded-[9.5px]"
					style={{
						background: 'linear-gradient(118deg, rgba(215, 237, 237, 0.16) -47.79%, rgba(204, 235, 235, 0.00) 100%)',
					}}
				></div>
				{otherChallenges?.map((challenge, i) => {
					return (
						<React.Fragment key={i}>
							<div key={challenge.title} className="">
								<ChallengeCard isHorizontalLayout={true} challenge={challenge} />
							</div>

							{i !== otherChallenges.length - 1 && <div className="border-b dark:border-[#c7c9d91a] my-[10px]"></div>}
						</React.Fragment>
					);
				})}
			</div>
		</div>
	);
};

export default OtherChallenges;
